import React, { useEffect, useState } from "react";
import axios from "axios";
import "../App.css";
import {
  FaEye,
  FaCheck,
  FaTimes,
  FaPlus,
  FaChevronLeft,
  FaChevronRight,
  FaFilter,
  FaDownload,
} from "react-icons/fa";
import { MdOutlineContentCopy, MdFilterList, MdClear } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { HiPlus, HiOutlineUsers, HiOutlineOfficeBuilding } from "react-icons/hi";
import { FiCalendar, FiShield, FiUsers, FiSettings } from "react-icons/fi";
import {
  Card,
  CardBody,
  CardHeader,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  SimpleGrid,
  Box,
  Text,
  ButtonGroup,
  Flex,
  Select,
  NumberInput,
  Stack,
  Divider,
  Badge,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Skeleton,
  SkeletonText,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  useToast,
  Collapse,
  VStack,
  HStack,
  Tooltip,
  Avatar,
  AvatarGroup,
  useColorModeValue,
  Container,
  Spacer,
  Center,
  Spinner,
} from "@chakra-ui/react";
import SearchInput from "../components/general/searchInput";
import MonthPicker from "../components/controls/MonthPicker";
import UserDetail from "./userDetail";
import { GrPowerReset } from "react-icons/gr";

const ManageUser = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [companyId, setCompanyId] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const toast = useToast();

  // Color mode values
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const whiteGrayBg = useColorModeValue("white", "gray.700");
  const shimmerGold = useColorModeValue("shimmer-gold", "shimmer-gold-dark");
  const shimmerSilver = useColorModeValue("shimmer-silver", "shimmer-silver-dark");
  const shimmerClass = useColorModeValue("shimmer-gold", "shimmer-gold-dark");
  const {
    isOpen: isModalOpen,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();
  const {
    isOpen: isDrawerOpen,
    onOpen: onOpenDrawer,
    onClose: onCloseDrawer,
  } = useDisclosure();

  const handleClick = (companyId) => {
    onOpenDrawer();
    setCompanyId(companyId);
  };

  const currentDate = new Date();
  const currentYearMonth = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}`;
  const [searchQuery, setSearchQuery] = useState("");
  const [itemPerPage, setItemPerPage] = useState(10);
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedUntilDate, setSelectedUntilDate] = useState("");
  const [searchedFromDate, setSearchedFromDate] = useState("");
  const [searchedUntilDate, setSearchedUntilDate] = useState("");
  const [selectedType, setSelectedType] = useState();
  const [searchedType, setSearchedType] = useState("");
  const [customer, setCustomer] = useState([]);

  const fetchCustomer = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/admin/manage-company`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const customer = response.data.companies;
      setCustomer(customer);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast({
        title: "Error",
        description: "Failed to load customer data",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
  }, []);

  const OverlayOne = () => (
    <ModalOverlay
      bg="blackAlpha.300"
      backdropFilter="blur(10px) hue-rotate(90deg)"
    />
  );

  const [overlay, setOverlay] = React.useState(<OverlayOne />);

  const [code, setCode] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [isGeneratingCode, setIsGeneratingCode] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setIsCopied(true);
      toast({
        title: "Copied!",
        description: "Code copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      toast({
        title: "Error",
        description: "Failed to copy code",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleGenerateCode = async () => {
    setIsGeneratingCode(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/code`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setCode(response.data.data.code);
    } catch (error) {
      console.error("Failed to generate code: ", error);
      toast({
        title: "Error",
        description: "Failed to generate code",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsGeneratingCode(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "entry") {
      setItemPerPage(value);
    } else if (name === "tipe") {
      const valueAsBoolean =
        value === "true" ? true : value === "false" ? false : "";
      setSelectedType(valueAsBoolean);
    }
  };

  const getVerifyText = (verified) => {
    switch (verified) {
      case true:
        return "Premium";
      case false:
        return "Free Trial";
      case "active":
        return "Active";
      case "inactive":
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  const getVerifyColorScheme = (verified) => {
    switch (verified) {
      case true:
        return "yellow";
      case false:
        return "gray";
      case "active":
        return "green";
      case "inactive":
        return "red";
      default:
        return "gray";
    }
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  const filteredData =
    customer &&
    customer.filter((data) => {
      const searchQueryLower = searchQuery.toLowerCase();

      const nameMatches = data.employee_name
        ? data.employee_name.toLowerCase().includes(searchQueryLower)
        : false;

      const companyNameMatches = data.company_name
        ? data.company_name.toLowerCase().includes(searchQueryLower)
        : false;

      const typeMatches =
        typeof data.verified === "boolean"
          ? (data.verified ? "premium" : "free trial").includes(
            searchQueryLower
          )
          : false;

      return nameMatches || companyNameMatches || typeMatches;
    });

  const UsedData = filteredData.filter((data) => {
    const JoinedDate = new Date(data.created_at);
    const ExpiredDate = new Date(data.company_expired);

    const fromDate = searchedFromDate ? new Date(searchedFromDate) : null;
    const untilDate = searchedUntilDate ? new Date(searchedUntilDate) : null;

    const isWithinMonthAndYear = (date, month, year) => {
      if (!date || month === null || year === null) return true;
      return date.getMonth() + 1 === month && date.getFullYear() === year;
    };

    const fromMonth = fromDate ? fromDate.getMonth() + 1 : null;
    const fromYear = fromDate ? fromDate.getFullYear() : null;
    const untilMonth = untilDate ? untilDate.getMonth() + 1 : null;
    const untilYear = untilDate ? untilDate.getFullYear() : null;

    const matchedType = searchedType === "" || data.verified === searchedType;
    const isAfterFromDate = fromDate
      ? isWithinMonthAndYear(JoinedDate, fromMonth, fromYear)
      : true;
    const isBeforeUntilDate = untilDate
      ? isWithinMonthAndYear(ExpiredDate, untilMonth, untilYear)
      : true;

    return matchedType && isAfterFromDate && isBeforeUntilDate;
  });

  const handleSearchClick = () => {
    setSearchedFromDate(selectedFromDate);
    setSearchedUntilDate(selectedUntilDate);
    setSearchedType(selectedType);
  };

  const resetFilters = () => {
    setSearchedType("");
    setSearchedFromDate("");
    setSearchedUntilDate("");
    setSelectedFromDate("");
    setSelectedUntilDate("");
    setSelectedType("");
    setSearchQuery("");
    fetchCustomer();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Statistics calculations
  const totalCustomers = customer.length;
  const premiumCustomers = customer.filter(c => c.verified === true).length;
  const activeCustomers = customer.filter(c => c.status === 'active').length;
  const totalEmployees = customer.reduce((sum, c) => sum + (c.total_employee_registered || 0), 0);

  const itemsPerPage = itemPerPage;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(UsedData.length / itemsPerPage);

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = indexOfFirstItem + itemsPerPage;
  const currentItems = UsedData.slice(indexOfFirstItem, indexOfLastItem);

  const renderTableSkeleton = () => {
    return Array(5).fill(0).map((_, index) => (
      <Tr key={index}>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
        <Td><Skeleton height="20px" /></Td>
      </Tr>
    ));
  };

  const renderData = () => {
    if (isLoading) {
      return renderTableSkeleton();
    }

    if (!currentItems || currentItems.length === 0) {
      return (
        <Tr>
          <Td colSpan={10}>
            <Center py={10}>
              <VStack spacing={3}>
                <HiOutlineUsers size={48} color="gray" />
                <Text fontSize="lg" color="gray.500" fontWeight="medium">
                  No customers found
                </Text>
                <Text fontSize="sm" color="gray.400">
                  Try adjusting your search or filter criteria
                </Text>
              </VStack>
            </Center>
          </Td>
        </Tr>
      );
    }

    return currentItems.map((data, index) => {
      const itemNumber = indexOfFirstItem + index + 1;
      return (
        <Tr key={data.id} _hover={{ bg: bg }}>
          <Td fontWeight="medium">{itemNumber}</Td>
          <Td>
            <VStack align="start" spacing={1}>
              <Text fontWeight="medium" fontSize="sm">
                {data.employee_name || "No Super Admin"}
              </Text>
              <Text fontSize="xs" color="gray.500">
                {data.company_email}
              </Text>
            </VStack>
          </Td>
          <Td>
            <HStack spacing={2}>
              <Avatar size="sm" name={data.company_name} />
              <Text fontWeight="medium" fontSize="sm">
                {data.company_name}
              </Text>
            </HStack>
          </Td>
          <Td>
            <Badge
              colorScheme={getVerifyColorScheme(data.verified)}
              size="sm"
              px={2}
              py={1}
              borderRadius="md"
              className={data.verified ? 'shimmer-gold' : 'shimmer-silver'}
            >
              <HStack spacing={1}>
                <FiShield size={12} />
                <Text fontSize="xs" fontWeight="semibold">
                  {getVerifyText(data.verified)}
                </Text>
              </HStack>
            </Badge>
          </Td>
          <Td>
            <HStack spacing={2}>
              <Text fontSize="sm" fontWeight="medium">
                {data.total_employee_registered || 0}
              </Text>
              <Text fontSize="xs" color="gray.400">/</Text>
              <Text fontSize="sm" color="gray.600">
                {data.total_employee || 0}
              </Text>
            </HStack>
          </Td>
          <Td>
            <Text fontSize="sm">{formatDate(data.created_at)}</Text>
          </Td>
          <Td>
            <Text fontSize="sm" color={data.company_expired ? "inherit" : "gray.400"}>
              {data.company_expired ? formatDate(data.company_expired) : "Not set"}
            </Text>
          </Td>
          <Td>
            <Badge
              colorScheme={getVerifyColorScheme(data.status)}
              size="sm"
              px={2}
              py={1}
              borderRadius="md"
            >
              <Text fontSize="xs" fontWeight="semibold">
                {getVerifyText(data.status)}
              </Text>
            </Badge>
          </Td>
          <Td>
            <Tooltip label="View Details" hasArrow>
              <IconButton
                size="sm"
                colorScheme="blue"
                variant="ghost"
                icon={<FaEye />}
                onClick={() => handleClick(data.id)}
                _hover={{ bg: "blue.50" }}
              />
            </Tooltip>
          </Td>
        </Tr>
      );
    });
  };

  const handlePageChange = (page) => {
    const newPage = Math.max(1, Math.min(totalPages, page));
    setCurrentPage(newPage);
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    const maxDisplayedPages = 5;
    const halfMaxDisplayedPages = Math.floor(maxDisplayedPages / 2);

    let startPage, endPage;

    if (currentPage <= halfMaxDisplayedPages + 1) {
      startPage = 1;
      endPage = Math.min(totalPages, maxDisplayedPages);
    } else if (currentPage >= totalPages - halfMaxDisplayedPages) {
      startPage = Math.max(1, totalPages - maxDisplayedPages + 1);
      endPage = totalPages;
    } else {
      startPage = currentPage - halfMaxDisplayedPages;
      endPage = startPage + maxDisplayedPages - 1;
    }

    return (
      <HStack spacing={1}>
        <IconButton
          size="sm"
          variant="ghost"
          icon={<FaChevronLeft />}
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        />

        {startPage > 1 && (
          <>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => handlePageChange(1)}
            >
              1
            </Button>
            {startPage > 2 && <Text fontSize="sm">...</Text>}
          </>
        )}

        {pageNumbers.slice(startPage - 1, endPage).map((number) => (
          <Button
            key={number}
            size="sm"
            variant={currentPage === number ? "solid" : "ghost"}
            colorScheme={currentPage === number ? "blue" : "gray"}
            onClick={() => handlePageChange(number)}
          >
            {number}
          </Button>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <Text fontSize="sm">...</Text>}
            <Button
              size="sm"
              variant="ghost"
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </Button>
          </>
        )}

        <IconButton
          size="sm"
          variant="ghost"
          icon={<FaChevronRight />}
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        />
      </HStack>
    );
  };

  const getShimmerClass = (verified) => {
    return verified ? "shimmer-gold" : "shimmer-silver";
  };

  const hasActiveFilters = searchedFromDate || searchedUntilDate || searchedType !== "" || searchQuery;

  return (
    <Box bg={bg} minH="100vh" className="main-container" p={{ base: 4, md: 6 }}>
      <Container maxW="7xl">
        <VStack spacing={6} align="stretch">
          {/* Header */}
          <Flex
            justify="space-between"
            align={{ base: "start", md: "center" }}
            direction={{ base: "column", md: "row" }}
            gap={4}
          >
            <VStack align="start" spacing={1}>
              <Text fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold" color="gray.800">
                Customer Management
              </Text>
              <Text fontSize="md" color="gray.600">
                Manage your customers and their subscriptions
              </Text>
            </VStack>

            <Button
              leftIcon={<HiPlus />}
              colorScheme="gray"
              size="lg"
              onClick={() => {
                handleGenerateCode();
                setOverlay(<OverlayOne />);
                onOpenModal();
              }}
              isLoading={isGeneratingCode}
              loadingText="Generating..."
            >
              Generate Premium Code
            </Button>
          </Flex>

          {/* Statistics Cards */}
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
            <Card bg={cardBg} shadow="sm">
              <CardBody>
                <Stat>
                  <StatLabel fontSize="sm" color="gray.600">Total Customers</StatLabel>
                  <StatNumber fontSize="2xl" color="blue.600">
                    {isLoading ? <Skeleton height="32px" width="60px" /> : totalCustomers}
                  </StatNumber>
                  <StatHelpText fontSize="xs">
                    <HiOutlineUsers style={{ display: "inline", marginRight: "4px" }} />
                    All registered companies
                  </StatHelpText>
                </Stat>
              </CardBody>
            </Card>

            <Card bg={cardBg} shadow="sm">
              <CardBody>
                <Stat>
                  <StatLabel fontSize="sm" color="gray.600">Premium Customers</StatLabel>
                  <StatNumber fontSize="2xl" color="yellow.600">
                    {isLoading ? <Skeleton height="32px" width="60px" /> : premiumCustomers}
                  </StatNumber>
                  <StatHelpText fontSize="xs">
                    <FiShield style={{ display: "inline", marginRight: "4px" }} />
                    Premium subscriptions
                  </StatHelpText>
                </Stat>
              </CardBody>
            </Card>

            <Card bg={cardBg} shadow="sm">
              <CardBody>
                <Stat>
                  <StatLabel fontSize="sm" color="gray.600">Active Companies</StatLabel>
                  <StatNumber fontSize="2xl" color="green.600">
                    {isLoading ? <Skeleton height="32px" width="60px" /> : activeCustomers}
                  </StatNumber>
                  <StatHelpText fontSize="xs">
                    <HiOutlineOfficeBuilding style={{ display: "inline", marginRight: "4px" }} />
                    Currently active
                  </StatHelpText>
                </Stat>
              </CardBody>
            </Card>

            <Card bg={cardBg} shadow="sm">
              <CardBody>
                <Stat>
                  <StatLabel fontSize="sm" color="gray.600">Total Employees</StatLabel>
                  <StatNumber fontSize="2xl" color="purple.600">
                    {isLoading ? <Skeleton height="32px" width="60px" /> : totalEmployees}
                  </StatNumber>
                  <StatHelpText fontSize="xs">
                    <FiUsers style={{ display: "inline", marginRight: "4px" }} />
                    Registered users
                  </StatHelpText>
                </Stat>
              </CardBody>
            </Card>
          </SimpleGrid>

          {/* Search and Filters */}
          <Card bg={cardBg} shadow="sm">
            <CardBody>
              <VStack spacing={4} align="stretch">
                {/* Search Bar and Filter Toggle */}
                <Flex justify="space-between" align="center" gap={4}>
                  <InputGroup maxW="400px" flex={1}>
                    <InputLeftElement>
                      <CiSearch color="gray" />
                    </InputLeftElement>
                    <Input
                      placeholder="Search customers, companies, or account types..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e.target.value)}
                      bg={whiteGrayBg}
                    />
                  </InputGroup>

                  <HStack spacing={2}>
                    {hasActiveFilters && (
                      <Badge colorScheme="blue" px={2} py={1} borderRadius="md">
                        {Object.values({ searchedFromDate, searchedUntilDate, searchedType: searchedType !== "", searchQuery }).filter(Boolean).length} active filters
                      </Badge>
                    )}
                    <Button
                      leftIcon={<MdFilterList />}
                      variant="outline"
                      size="sm"
                      onClick={() => setShowFilters(!showFilters)}
                      colorScheme={showFilters ? "blue" : "gray"}
                    >
                      Filters
                    </Button>
                    {hasActiveFilters && (
                      <Button
                        leftIcon={<MdClear />}
                        variant="ghost"
                        size="sm"
                        onClick={resetFilters}
                        colorScheme="red"
                      >
                        Clear
                      </Button>
                    )}
                  </HStack>
                </Flex>

                {/* Collapsible Filters */}
                <Collapse in={showFilters}>
                  <Box p={4} bg={bg} borderRadius="md">
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                      <VStack align="start" spacing={2}>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                          Join Month
                        </Text>
                        <MonthPicker
                          className="text-black rounded-lg w-full form-control"
                          selectedDate={selectedFromDate}
                          onChange={(date) => setSelectedFromDate(date)}
                        />
                      </VStack>

                      <VStack align="start" spacing={2}>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                          Expiry Month
                        </Text>
                        <MonthPicker
                          className="text-black rounded-lg w-full form-control"
                          selectedDate={selectedUntilDate}
                          onChange={(date) => setSelectedUntilDate(date)}
                        />
                      </VStack>

                      <VStack align="start" spacing={2}>
                        <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                          Account Type
                        </Text>
                        <Select
                          name="tipe"
                          onChange={handleChange}
                          value={selectedType}
                          bg={whiteGrayBg}
                        >
                          <option value="">All Types</option>
                          <option value="true">Premium</option>
                          <option value="false">Free Trial</option>
                        </Select>
                      </VStack>
                    </SimpleGrid>

                    <Flex justify="flex-end" mt={4} gap={3}>
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => setShowFilters(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={handleSearchClick}
                        leftIcon={<CiSearch />}
                      >
                        Apply Filters
                      </Button>
                    </Flex>
                  </Box>
                </Collapse>
              </VStack>
            </CardBody>
          </Card>

          {/* Data Table */}
          <Card bg={cardBg} shadow="sm">
            <CardBody p={0}>
              <TableContainer>
                <Table variant="simple" size="sm">
                  <Thead bg={bg}>
                    <Tr>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">#</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Customer</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Company</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Account Type</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Members</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Joined</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Expires</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Status</Th>
                      <Th fontSize="xs" fontWeight="bold" color="gray.600">Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {renderData()}
                  </Tbody>
                </Table>
              </TableContainer>

              {/* Pagination Footer */}
              {!isLoading && UsedData.length > 0 && (
                <Box p={4} borderTop="1px" borderColor={borderColor}>
                  <Flex
                    justify="space-between"
                    align="center"
                    direction={{ base: "column", md: "row" }}
                    gap={4}
                  >
                    <HStack spacing={2}>
                      <Text fontSize="sm" color="gray.600">
                        Showing {indexOfFirstItem + 1} to{" "}
                        {Math.min(indexOfLastItem, UsedData.length)} of {UsedData.length} results
                      </Text>
                      <Divider orientation="vertical" h="20px" />
                      <HStack spacing={2}>
                        <Text fontSize="sm" color="gray.600">Show</Text>
                        <Select
                          size="sm"
                          w="70px"
                          value={itemPerPage}
                          onChange={(e) => setItemPerPage(Number(e.target.value))}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                        </Select>
                        <Text fontSize="sm" color="gray.600">per page</Text>
                      </HStack>
                    </HStack>

                    {renderPagination()}
                  </Flex>
                </Box>
              )}
            </CardBody>
          </Card>
        </VStack>
      </Container>

      {/* Generate Code Modal */}
      <Modal isCentered isOpen={isModalOpen} onClose={onCloseModal}>
        {overlay}
        <ModalContent>
          <ModalHeader>
            <HStack spacing={2}>
              <FiShield />
              <Text>Premium Access Code</Text>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Box textAlign="center" p={4} bg={shimmerGold} borderRadius="md" border="1px solid" borderColor="yellow.200">
                <HStack justify="center" spacing={2} mb={2}>
                  <FiShield color="orange" />
                  <Text fontSize="sm" fontWeight="semibold" color="yellow.800">
                    Premium Customer Access Code
                  </Text>
                </HStack>
                <Text fontSize="xs" color="yellow.700">
                  Share this code with customers to grant premium access
                </Text>
              </Box>

              {code ? (
                <Box textAlign="center" p={6} bg={bg} borderRadius="lg" border="2px dashed" borderColor="gray.300">
                  <Text fontSize="3xl" fontWeight="bold" fontFamily="mono" color="blue.600" mb={3}>
                    {code}
                  </Text>
                  <Button
                    leftIcon={isCopied ? <FaCheck /> : <MdOutlineContentCopy />}
                    colorScheme={isCopied ? "green" : "blue"}
                    variant="outline"
                    size="sm"
                    onClick={handleCopy}
                  >
                    {isCopied ? "Copied!" : "Copy Code"}
                  </Button>
                </Box>
              ) : (
                <Center py={8}>
                  <Spinner size="lg" color="blue.500" />
                </Center>
              )}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseModal} colorScheme="gray" variant="ghost">
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Customer Detail Drawer */}
      <Drawer
        isOpen={isDrawerOpen}
        placement="right"
        onClose={onCloseDrawer}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <HStack spacing={2}>
              <FiSettings />
              <Text>Customer Details</Text>
            </HStack>
          </DrawerHeader>
          <DrawerBody px={0}>
            <UserDetail
              companyId={companyId}
              onCustomerUpdated={fetchCustomer}
              onClose={onCloseDrawer}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default ManageUser;